import Quill from "quill";

const Parchment = Quill.import("parchment");

const ClassAttributor = new Parchment.Attributor("classNames", "class", {
  scope: Parchment.Scope.INLINE_ATTRIBUTE,
});

const DiffHighlightClass = new Parchment.Attributor(
  "diffHighlight",
  "data-diff",
  {
    scope: Parchment.Scope.INLINE_ATTRIBUTE,
  },
);

Quill.register(ClassAttributor, true);
Quill.register(DiffHighlightClass, true);

export default Quill;
